import React from 'react';
import StyleButton from './StyleButton';
import { UnorderedListOutlined, OrderedListOutlined } from '@ant-design/icons';

const BLOCK_TYPES = [
    { label: <UnorderedListOutlined />, style: 'unordered-list-item' },
    { label: <OrderedListOutlined />, style: 'ordered-list-item' }
];

const BlockStyleControls = ( { editorState, onToggle } ) => {
    const selection = editorState.getSelection();
    const blockType = editorState
        .getCurrentContent()
        .getBlockForKey( selection.getStartKey() )
        .getType();

    return (
        <div className="rte-control-group">
            { BLOCK_TYPES.map( ( type ) =>
                <StyleButton
                    key={ type.style }
                    active={ type.style === blockType }
                    label={ type.label }
                    onToggle={ onToggle }
                    style={ type.style }
                />
            ) }
        </div>
    );
};

export default BlockStyleControls;